import React from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { IoWarningOutline } from "react-icons/io5";
import { RiErrorWarningLine, RiInformation2Line } from "react-icons/ri";
import { useSelector } from "react-redux";

const ToastMessage = () => {
  const { type, message } = useSelector((state) => state.toast);

  switch (type) {
    case "SUCCESS":
      return (
        <div className="toast toast-top toast-end md:toast-center z-50">
          <div className="flex items-center gap-2 alert bg-toastSuccess rounded-md p-3">
            <IoMdCheckmarkCircleOutline className="text-alertSuccess text-2xl" />
            <span className="text-alertSuccess">{message}</span>
          </div>
        </div>
      );

    case "WARNING":
      return (
        <div className="toast toast-top toast-end md:toast-center z-50">
          <div className="flex items-center gap-2 alert bg-toastWarning rounded-md p-3">
            <IoWarningOutline className="text-alertWarning text-2xl" />
            <span className="text-alertWarning">{message}</span>
          </div>
        </div>
      );

    case "ERROR":
      return (
        <div className="toast toast-top toast-end md:toast-center z-50">
          <div className="flex items-center gap-2 alert bg-toastError rounded-md p-3">
            <RiErrorWarningLine className="text-alertError text-2xl" />
            <span className="text-alertError">{message}</span>
          </div>
        </div>
      );

    default:
      return (
        <div className="toast toast-top toast-end md:toast-center z-50">
          <div className="flex items-center gap-2 alert bg-toastInfo rounded-md p-3">
            <RiInformation2Line className="text-alertInfo text-2xl" />
            <span className="text-alertInfo">{message}</span>
          </div>
        </div>
      );
  }
};

export default ToastMessage;
